import { useEffect, useState } from 'react';
import { Cradle, UsageStats } from '@solo/app-core';
import { Button, Flex, RouterLink, Text } from '@/app/ui/atoms';
import { useCradle } from '@/app/contexts';
import UsageDetailsList from '@/app/ui/organisms/Usages/UsageDetailsList';
import { translate } from '@/app/i18n';
import Colors from '@/app/styles/Colors';

const TopSongsPlatform = () => {
  const [usagesData, setUsagesData] = useState<UsageStats[]>([]);

  const { statisticsBloc } = useCradle<Cradle>();

  async function getUsageDetail() {
    const usagesFiltered = await statisticsBloc.getUsages({
      limit: 5,
    });

    setUsagesData(usagesFiltered.data);
  }
  useEffect(() => {
    getUsageDetail();
  }, []);

  return (
    <Flex.Container flexDirection="column" className="mt-5" gap="5rem">
      {usagesData.length > 0 && (
        <>
          <UsageDetailsList usages={usagesData} />
          <Flex.Container justifyContent="center">
            <RouterLink to="/music-usage/usage-detail" style={{ width: '25%' }}>
              <Button
                $size="sm"
                $variant="primary"
                $backgroundColor={Colors.transparent}
                $backgroundColorHover={Colors.transparent}
              >
                <Text.Paragraph style={{ padding: 0 }} fontWeight={600}>
                  {translate('EARNINGS.SEE_ALL')}
                </Text.Paragraph>
              </Button>
            </RouterLink>
          </Flex.Container>
        </>
      )}
      {usagesData.length === 0 && <Text.Anotation>{translate('USAGES.NO_DATA')}</Text.Anotation>}
    </Flex.Container>
  );
};

export default TopSongsPlatform;
